export default __webpack_public_path__ + "static/media/value_06.05b143e9.png";